const defaultRequestOptions = {
  agencyProvider: {
    include_agency_provider_provider: true,
    include_agency_provider_service: true,
    include_service_categories: true,
  },
  campaignQuoteItem: {
    include_campaign_quote_item_publication: true,
    include_campaign_quote_item_deep_link: true,
    include_campaign_quote_item_publication_edition: true,
    include_campaign_quote_item_publication_package: true,
    include_campaign_quote_item_quote_dynamic_items: true,
    include_campaign_quote_item_quote_total: true,
  },
  campaignQuoteTemplateItem: {
    include_campaign_quote_template_item_publication: true,
    include_campaign_quote_template_item_publication_edition: true,
    include_campaign_quote_template_item_publication_package: true,
    include_campaign_quote_template_item_quote_dynamic_items: true,
    include_campaign_quote_template_item_quote_total: true,
  },
  defaultQuoteItem: {},
  favouriteOrder: {
    include_favourite_order_items: true,
  },
  order: {
    include_order_bundle: true,
    include_order_item_deep_link: true,
    include_order_item_service: true,
    include_order_item_service_product: true,
    include_order_item_status: true,
    include_order_item_tasks: true,
    include_order_items: true,
    include_order_publication: true,
    include_order_publication_edition: true,
    include_order_publication_package: true,
    include_order_status: true,
    include_publication_edition_deadlines: true,
  },
  orderBundle: {
    include_order_bundle_items: true,
  },
  orderBundleItem: {
    include_order_bundle_item_publication: true,
  },
  providerPackage: {
    include_provider_package_items: true,
  },
  providerPriceList: {
    agency_price_list_only: true,
    include_provider_price_list_previous_price_list: true,
    include_provider_price_list_product_items: true,
    include_provider_price_list_products: true,
  },
  providerPriceListProductUnlock: {
    include_product_unlock_unlock_price_list: true,
    include_product_unlock_unlock_price_list_item: true,
  },
  publication: {
    agency_publications_only: true,
    include_publication_logo: true,
  },
  publicationEdition: {
    include_publication_edition_deadlines: true,
  },
  service: {
    include_service_assigned_agency_provider_ids: true,
    include_service_categories: true,
  },
}

export default defaultRequestOptions
